<template>
  <soha-page-loading v-if="loading" />
  <div v-else>
    <soha-resume
      :resume="jobseekerResume"
      color-variant="third"
      @resumeUpdated="resumeUpdated"
    />
    <div
      v-if="jobRedirectInfo"
      class="soha-job-redirect-box"
      :class="{ fixed: !endOfScroll }"
    >
      <span
        class="d-block text-justify primary-color"
        :class="{ 'mb-5': !endOfScroll }"
      >
        {{
          $t(`${I18nPrefix}SEND_RESUME_DESCRIPTION`, {
            jobTitle: jobRedirectInfo.title,
            companyName: jobRedirectInfo.companyName,
          })
        }}
      </span>
      <soha-button
        :text="$t(`${I18nPrefix}SEND_RESUME`)"
        height="35"
        @click="submitResume()"
        :class="{ 'w-100': !endOfScroll }"
        :loading="sendResumeLoading"
      />
    </div>

    <soha-modal id="descrition">
      <template v-slot:body>
        <p class="text-justify font-size-h5 line-height-xl">
          {{ $t(`${I18nPrefix}MODAL_MESSAGE`) }}
        </p>
      </template>

      <template v-slot:footer>
        <div class="d-flex justify-content-end w-100">
          <soha-button
            name="close"
            :text="$t(`${I18nPrefix}CLOSE`)"
            @click="$bvModal.hide('descrition')"
          />
        </div>
      </template>
    </soha-modal>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";
import GeneralMixin from "@/mixins/GeneralMixin";
import ValidationMixin from "@/mixins/ValidationMixin";
import SohaResume from "@/view/components/resume/Resume";
import { mapGetters } from "vuex";
export default {
  name: "jobseekerResumeEdit",

  mixins: [UIMixin, GeneralMixin, ValidationMixin],

  components: {
    SohaResume,
  },

  data() {
    return {
      I18nPrefix: "JOB_SEEKER.PAGES.RESUME.RESUME.",
      loading: false,
      sendResumeLoading: false,
      endOfScroll: false,
      jobRedirectInfo: null,
      screenSize: null,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.updateScroll);
    this.handleResize();
    this.jobRedirectInfo = this.getJobRedirectData;
    this.$store.commit("removeJobRedirectData");
    if (this.$route.params.showDescritionModal)
      this.$bvModal.show("descrition");
  },

  destroyed() {
    window.removeEventListener("scroll", this.updateScroll);
  },

  methods: {
    handleResize() {
      this.screenSize = window.innerWidth;
    },

    updateScroll() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isAtBottom =
        window.innerHeight + this.scrollTop >=
        document.documentElement.scrollHeight - 300;

      this.endOfScroll = isAtBottom;
    },

    submitResume() {
      this.sendResumeLoading = true;
      ApiService.post("api/v2/jobseeker/resume/send-to-job", {
        jobId: this.jobRedirectInfo.id,
        aboutMe: this.jobRedirectInfo.aboutMe,
        visitorId: sessionStorage.getItem("soha_visitor_id"),
      })
        .then((res) => {
          if (res.data.code == 201) {
            this.successToast(res.data.message);
            this.jobRedirectInfo = null;
          } else this.errorToast(res.data.message);
        })
        .finally(() => {
          this.sendResumeLoading = false;
        });
    },

    resumeUpdated() {
      this.$store.dispatch("jobseekerResume");
    },
  },

  computed: {
    ...mapGetters(["getJobRedirectData", "jobseekerResume"]),
  },
};
</script>

<style scoped>
.soha-job-redirect-box {
  border-radius: 0.7rem;
  padding: 1rem;
  z-index: 10;
  margin-bottom: 1rem;
  background: white;
  left: 1.5rem;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.soha-job-redirect-box.fixed {
  position: fixed;
  bottom: 0;
  max-width: 20rem;
  display: inline !important;
}
@media (max-width: 767px) {
  .soha-job-redirect-box.fixed {
    max-width: 100%;
  }
}
@media (max-width: 400px) {
  .soha-job-redirect-box {
    display: inline-block !important;
  }
  .soha-job-redirect-box button {
    width: 100% !important;
  }
}
</style>
